/// <reference types="@rspack/core/module" />
import ReactOnRails from "react-on-rails";

import "../bundles/shared/v1/WebComponents/index";

import AddOnsApp from "../bundles/AddOns/AddOnsApp";
import AddOnsBillingApp from "../bundles/AddOnsBilling/AddOnsBillingApp";
import AddOnsSupportApp from "../bundles/Support/Account/AddOnsSupport/AddOnsSupportApp";
import AccountFinancialApp from "../bundles/Financials/startup/AccountFinancialApp";
import AccountUsersApp from "../bundles/Settings/Users";
import PhoneSettingsApp from "../bundles/Settings/Phone/PhoneSettingsApp";
import ReportingGoals from "../bundles/Goals/components/ReportingGoalsApp";
import AgreementFilters from "../bundles/Filters/components/AgreementFilters/AgreementFilters";
import AssignedPlansApp from "../bundles/AssignedPlans/startup/AssignedPlansApp";
import AutoPlanEditApp from "../bundles/AutoPlans/startup/AutoPlanEditApp";
import AutoPlanFilters from "../bundles/Filters/components/AutoPlans/AutoPlanFilters";
import AutoPlansApp from "../bundles/AutoPlans/startup/AutoPlansApp";
import BusinessSettings from "../bundles/BusinessSettings/startup/BusinessSettings";
import BulkApplyMarketReportsApp from "../bundles/MarketReports/BulkApplyMarketReports/BulkApplyMarketReportsApp";
import CompletenessTooltip from "../bundles/Filters/components/CompletenessTooltip/CompletenessTooltip";
import ConferenceCall from "../bundles/Interactions/ConferenceCall/startup/ConferenceCallApp";
import ConferenceCallButton from "../bundles/Interactions/ConferenceCall/startup/ConferenceCallButtonApp";
import DashboardApp from "../bundles/Dashboard/components/DashboardApp";
import DisabledHistoryFields from "../bundles/Filters/components/DisabledHistoryFields";
import EnableTextForwarding from "../bundles/EnableTextForwarding";
import ExcludeTagFilter from "../bundles/Filters/components/ExcludeTagFilter";
import GabbiAiSettingsApp from "../bundles/GabbiAISettings/GabbiAiSettingsApp";
import StageFilter from "../bundles/Filters/components/StageFilter";
import SourceFilter from "../bundles/Filters/components/SourceFilter";
import LeadsFilterNav from "../bundles/Filters/components/LeadsFilterNav";
import TextAndPhoneTooltip from "../bundles/Filters/components/TextAndPhoneTooltip/TextAndPhoneTooltip";
import HeaderApp from "../bundles/Layout/Header/HeaderApp";
import ImageSizeErrorModal from "../bundles/Account/ImageSizeErrorModal";
import InboxApp from "../bundles/Inbox/startup/InboxApp";
import PondOrAgentFilter from "../bundles/Filters/components/PondOrAgentFilter";
import IncludeTagFilter from "../bundles/Filters/components/IncludeTagFilter";
import LeadDNA from "../bundles/LeadDNA/components/LeadDNA";
import LeadPondsApp from "../bundles/LeadPonds/index";
import LeadIndexApp from "../bundles/LeadIndex/index";
import LeadIndexButtonApp from "../bundles/ContactMergeModal/LeadIndexButtonApp";
import LeadRoutingTargetSelector from "../bundles/LeadRoutingTargetSelector";
import FormAgentOrPondSelect from "../bundles/shared/FormAgentOrPondSelect";
import MarketReportFilters from "../bundles/Filters/components/MarketReports/MarketReportFilters";
import MassSendListingAlerts from "../bundles/ListingAlerts/components/MassSendListingAlerts";
import MassSendMailerCampaignApp from "../bundles/MassSendMailerCampaign/component/MassSendMailerCampaignApp";
import MassSendHandwrittenCardApp from "../bundles/LeadIndex/components/MassSendHandwrittenCard/MassSendHandwrittenCardApp";
import MassUpdateStageModal from "../bundles/LeadIndex/components/MassUpdateStageModal";
import MilestonesApp from "../bundles/Milestones/startup/MilestonesApp";
import ManageAccess from "../bundles/ManageAccess/components/ManageAccess";
import NewProjectModal from "../bundles/Projects/NewProjectModal";
import OtherInteract from "../bundles/People/components/OtherInteract";
import PartnerSearch from "../bundles/PartnerSearch";
import PersonalApp from "../bundles/Account/PersonalApp";
import PersonDetailApp from "../bundles/PersonDetail/startup/PersonDetailApp";
import PhoneSystemPurchaseApp from "../bundles/PhoneSystem/Purchase/PhoneSystemPurchaseApp";
import PolymorphicTasks from "../bundles/Tasks/components/PolymorphicTasks";
import ReportsApp from "../bundles/Reports/startup/ReportsApp";
import SingleDialerApp from "../bundles/Dialer/SingleDialerApp";
import TwilioManageNumbers from "../bundles/TwilioSupport/TwilioManageNumbers";
import TwilioTollFree from "../bundles/TwilioTollFree/components/TwilioTollFree";
import TwilioSubaccountSid from "../bundles/TwilioSupport/TwilioSubaccountSid";
import SearchListingsApp from "../bundles/SearchListings/startup/SearchListingsApp";
import SidebarApp from "../bundles/Layout/Sidebar/SidebarApp";
import SharedAutoPlansApp from "../bundles/SharedAutoPlans/components/SharedAutoPlansApp";
import SmsModalButtonApp from "../bundles/SmsModal/components/SmsModalButtonApp";
import Sources from "../bundles/Sources/components/Sources";
import SuperUsersIndex from "../bundles/Support/SuperUsers/index";
import SupportAccountFeatures from "../bundles/Support/Account/Features";
import SupportTransactionFinancials from "../bundles/Support/Account/Financials/TransactionFinancials";
import SupportUsersIndex from "../bundles/Support/Users/index";
import TaskApp from "../bundles/Tasks/components/TaskApp";
import TimelinesApp from "../bundles/Timelines/components/TimelinesApp";
import TransactionDetailsPage from "../bundles/TransactionDetailsPage";
import TransactionFinancialApp from "../bundles/Financials/startup/TransactionFinancialApp";
import TransactionsIndex from "../bundles/Transactions/components/Wrapper";
import WebsiteSearchHistoryFilter from "../bundles/Filters/components/WebsiteSearchHistoryFilter";
import WebsiteApp from "../bundles/Website/WebsiteApp";
import IndexSendListingsApp from "../bundles/SearchListings/components/IndexSendListingsApp";
import NotesApp from "../bundles/Transactions/components/Notes/startup/NotesApp";
import TwilioTrustHub from "../bundles/TwilioTrustHub/components/TwilioTrustHub";
import SuperUsersBranding from "../bundles/Support/SuperUsers/Branding";
import BrandedFeatureFlags from "../bundles/Support/BrandedFeatureFlags/BrandedFeatureFlags";
import TransactlyCoordinators from "../bundles/Support/TransactlyCoordinators/TransactlyCoordinators";
import SsoAudits from "../bundles/Support/SsoAudits/SsoAudits";
import PPCAddsDashboard from "../bundles/Support/PPCAddsDashboard/PPCAddsDashboard";
import DeleteAutoPlans from "../bundles/Support/DeleteAutoPlans/DeleteAutoPlans";
import OktaPasswordReset from "../bundles/OktaPasswordReset";
import OktaError from "../bundles/OktaError";
import layoutStore from "../bundles/store/layoutStore";
import AppliedFiltersApp from "../bundles/LeadIndex/components/AppliedFiltersApp";
import EmailAllModalApp from "../bundles/LeadIndex/components/EmailAllModal/EmailAllModalApp";
import SettingsTemplatesApp from "../bundles/SettingsTemplates/SettingsTemplatesApp";
import PhoneSystemApp from "../bundles/PhoneSystem/PhoneSystemApp";
import OpportunitiesApp from "../bundles/Opportunities/startup/OpportunitiesApp";
import Tags from "../bundles/Tags/Tags";
import OpportunitiesPurchaseApp from "../bundles/Opportunities/components/OpportunitiesPurchaseApp/OpportunitiesPurchaseApp";
import SalesFormApp from "../bundles/Support/SalesForm/SalesFormApp";
import TransactlyLazy from "../bundles/Transactly/TransactlyLazy";

// @ts-expect-error TODO: layoutStore is not typed correctly
ReactOnRails.registerStoreGenerators({ layoutStore });

ReactOnRails.register({
  AccountFinancialApp,
  AccountUsersApp,
  AddOnsApp,
  AddOnsBillingApp,
  AddOnsSupportApp,
  AgreementFilters,
  AppliedFiltersApp,
  AssignedPlansApp,
  AutoPlanEditApp,
  AutoPlanFilters,
  AutoPlansApp,
  BulkApplyMarketReportsApp,
  MassSendMailerCampaignApp,
  MassSendHandwrittenCardApp,
  BusinessSettings,
  CompletenessTooltip,
  ConferenceCall,
  ConferenceCallButton,
  DashboardApp,
  DisabledHistoryFields,
  EmailAllModalApp,
  EnableTextForwarding,
  ExcludeTagFilter,
  GabbiAiSettingsApp,
  StageFilter,
  SourceFilter,
  LeadsFilterNav,
  TextAndPhoneTooltip,
  HeaderApp,
  InboxApp,
  PondOrAgentFilter,
  ImageSizeErrorModal,
  IncludeTagFilter,
  IndexSendListingsApp,
  LeadDNA,
  LeadPondsApp,
  LeadIndexApp,
  LeadIndexButtonApp,
  LeadRoutingTargetSelector,
  FormAgentOrPondSelect,
  MarketReportFilters,
  MassSendListingAlerts,
  MassUpdateStageModal,
  MilestonesApp,
  ManageAccess,
  NewProjectModal,
  OktaError,
  OktaPasswordReset,
  OtherInteract,
  PartnerSearch,
  PersonalApp,
  PersonDetailApp,
  PhoneSystemPurchaseApp,
  PolymorphicTasks,
  ReportingGoals,
  ReportsApp,
  TwilioManageNumbers,
  TwilioTollFree,
  TwilioSubaccountSid,
  SearchListings: SearchListingsApp,
  SidebarApp,
  SharedAutoPlansApp,
  SmsModalButtonApp,
  Sources,
  SuperUsersIndex,
  SupportAccountFeatures,
  SupportTransactionFinancials,
  SupportUsersIndex,
  TaskApp,
  TimelinesApp,
  TransactionDetailsPage,
  TransactionFinancialApp,
  TransactionsIndex,
  WebsiteSearchHistoryFilter,
  NotesApp,
  TwilioTrustHub,
  SuperUsersBranding,
  BrandedFeatureFlags,
  TransactlyCoordinators,
  DeleteAutoPlans,
  SettingsTemplatesApp,
  PhoneSettingsApp,
  PhoneSystemApp,
  SingleDialerApp,
  OpportunitiesApp,
  OpportunitiesPurchaseApp,
  SsoAudits,
  PPCAddsDashboard,
  WebsiteApp,
  Tags,
  SalesFormApp,
  TransactlyLazy,
});

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept();
}
